import { useState } from 'react';
import { Link } from 'react-router-dom';
import { faqs } from '@/mocks/products';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="py-20 md:py-28 bg-stone-50">
      <div className="w-full px-4 sm:px-6 lg:px-12 xl:px-20">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20">
          <div>
            <p className="text-amber-600 text-sm font-semibold uppercase tracking-widest mb-2">Have Questions?</p>
            <h2 className="font-display text-4xl md:text-5xl font-bold text-stone-900 mb-5">Frequently Asked Questions</h2>
            <p className="text-stone-400 text-base leading-relaxed mb-8">Everything you need to know about Faasley products and services.</p>
            <div className="bg-stone-900 rounded-2xl p-7 text-white">
              <h3 className="font-display font-bold text-lg mb-2">Still have questions?</h3>
              <p className="text-white/50 text-sm mb-5">Our team is happy to help with anything you need.</p>
              <Link to="/contact" className="inline-flex items-center gap-2 bg-amber-500 hover:bg-amber-400 text-white font-semibold px-6 py-3 rounded-full text-sm transition-colors whitespace-nowrap">
                <i className="ri-customer-service-line"></i>Contact Support
              </Link>
            </div>
          </div>
          <div className="space-y-3">
            {faqs.slice(0, 6).map((faq, index) => (
              <div key={index} className={`bg-white rounded-2xl border transition-all duration-300 ${openIndex === index ? 'border-amber-200' : 'border-stone-100'}`}>
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)}
                  className="w-full flex items-center justify-between p-5 text-left cursor-pointer">
                  <span className="font-semibold text-stone-900 text-sm pr-4">{faq.question}</span>
                  <div className={`w-7 h-7 rounded-full flex items-center justify-center flex-shrink-0 transition-all ${openIndex === index ? 'bg-amber-500 text-white' : 'bg-stone-100 text-stone-400'}`}>
                    <i className={`ri-${openIndex === index ? 'subtract' : 'add'}-line text-sm`}></i>
                  </div>
                </button>
                <div className={`overflow-hidden transition-all duration-300 ${openIndex === index ? 'max-h-60' : 'max-h-0'}`}>
                  <div className="px-5 pb-5">
                    <p className="text-stone-500 text-sm leading-relaxed">{faq.answer}</p>
                  </div>
                </div>
              </div>
            ))}
            <div className="text-center pt-2">
              <Link to="/faq" className="inline-flex items-center gap-2 text-amber-600 font-semibold text-sm hover:underline">
                View all FAQs <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
